<template>
    <div class="input-group input-group-merge"
         @click="filesInput.click()"
         style="cursor: pointer;">
        <div class="input-group-prepend input-group-text bg-light">
            <i class="bi-upload text-dark"></i>
        </div>
        <div class="form-control input" :class="{ 'WithFiles pt-1 pb-2': files.length }">
            <template v-if="files.length">
                <span class="FileUpload badge border-start border-end border-2
                    bg-light text-primary mx-1 mt-1"
                    v-for="{name} in files"
                >
                    {{ name }}
                </span>
            </template>
            <template v-else>
                <span class="ms-2">{{ $t('No files chosen') }}</span>
            </template>
        </div>
        <input
            v-show="false"
            type="file"
            ref="filesInput"
            @change="updateFile($event)"
            :accept="accept"
            multiple
        />
    </div>
</template>

<script setup>
import { computed, ref, useTemplateRef } from "vue";

const props = defineProps({
    accept: {
        type: String,
        default: ".usr,.idx,.evt,.log,.set"
    }
})
const emit = defineEmits(['update:files'])

const filesInput = ref(null);
const files = ref([]);

const fileNames = computed(() => {
    return files.value?.map(_f => _f.name)?.join(", ")
})
function updateFile(event) {
    files.value = Array.from(event.target.files);
    if (files.value.length > 0) {
        console.log('files', files.value)
        emit('update:files', files.value)
        // emit('update:filename', event.target.files[0].name)
    }
}
</script>


<style scoped>
.form-control.input {
    .FileUpload {
        font-size: .92em;
    }
    overflow: auto;
    scrollbar-width: thin;
    scrollbar-color: #0002 #AAA1;
    &::before{
        border: none;
    }
    &::after{
        border: none;
    }
}
</style>
